export enum PROGRAM_RULE_TYPES {
  VERIFICATION_RULE = 'VERIFICATION_RULE',
  PAYOUT_RULE = 'PAYOUT_RULE',
  PROJECT_RULE = 'PROJECT_RULE',
  PORTFOLIO_RULE = 'PORTFOLIO_RULE',
  APPLICATION_STATUS_RULE = 'APPLICATION_STATUS_RULE',
  PROGRAM_SETTINGS = 'PROGRAM_SETTINGS',
  PROJECT_STAGE_RULE = 'PROJECT_STAGE_RULE',
  CONNECTIONS_WIZARD = 'CONNECTIONS_WIZARD',
  CONNECTIONS_SUBMISSION_POLICY = 'CONNECTIONS_SUBMISSION_POLICY'
}
